import React from "react";
import Section from "../components/Section";

export default function Education() {
  return (
    <Section id="education" title="Education">
      <div className="d-flex flex-column flex-md-row justify-content-between mb-5">
        <div className="flex-grow-1">
          <h3 className="mb-0">INDIAN INSTITUTE OF INFORMATION TECHNOLOGY, DESIGN AND MANUFACTURING, JABALPUR</h3>
          <div className="subheading mb-3">B.TECH IN ELECTRONICS & COMMUNICATION</div>
          <div>Web Development, Data Structures, Competitive Programming, Algorithms, OOPs, DBMS</div>
          <p>CGPA: 8.2</p>
        </div>
        <div className="flex-shrink-0">
          <span className="text-primary">November 2020 - Present</span>
        </div>
      </div>
    </Section>
  );
}
